import {
    GET_FEATURES_REQUEST,
    GET_FEATURES_SUCCESS,
    GET_FEATURES_FAILURE,
    POST_FEATURES_SUCCESS,
} from '../constants/';

const INIT_STATE = {
    isLoading: false,
    isInitialFetch: true,
    data: [],
    error: null,
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_FEATURES_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_FEATURES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.features,
                isInitialFetch: false,
            };
        case GET_FEATURES_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
        
            case POST_FEATURES_SUCCESS:
                return {
                    ...state,
                    isLoading: false,
                    data: action.payload.features,
                    isInitialFetch: false,
                };
        default:
            return state;
    }
};